





























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { contributeList, oneClickCollection } from '@/api/contribute';
import { hasPermission } from '@/utils/utils';
import moment from 'moment';
import { mapGetters } from 'vuex';

const roleMap = {
  0: 'source',
  1: 'sponsor'
};

const confirmMap = {
  0: '待确认',
  1: '确认',
  2: '存在异议',
  3: '退回'
};

@Component({ computed: { ...mapGetters(['userInfo'])}})
class ProjectContribution extends Vue {
  userInfo: any;
  filterNow: number = 0;
  columns: any[] = [];
  data: any[] = [];
  keyword: string = '';
  confirmMap: object = confirmMap;
  total: number = 0;
  pageSize: number = 10;
  permissions: object = {
    hasCreate: false,
    hasUrge: false
  };
  loading: boolean = false;
  appId: string = '';

  created() {
    const { permissions:queue } = this.userInfo || {};
    this.permissions['hasCreate'] = hasPermission(queue, '/systemSetting/manage/projectContribution/createContribution');
    this.permissions['hasUrge'] = hasPermission(queue, '/systemSetting/manage/projectContribution/urge');
    this.getList(1);
    if (window.location.host === 'hubble.sourcecodecap.com:8050') {
      this.appId = 'cli_a2944d3d4c22900e';
    } else if (/hubble/.test(window.location.host)) {
      this.appId = 'cli_9f8f27b375fbd00c';
    } else if (/pretianchi/.test(window.location.host)) {
      this.appId = 'cli_a13c47f49878900b';
    } else if (/tianchi/.test(window.location.host)) {
      this.appId = 'cli_9e32766f10b9900e';
    }
  }

  toPath(pathTo) {
    this.$router.push({ path: '/systemSetting/manage/projectContribution/' + pathTo });
  }

  async getList(page) {
    try {
      this.data = [];
      let res = await contributeList({ page: page, pageSize: this.pageSize, completeStatus: this.filterNow, companyName: this.keyword });
      if (res.code === 200) {
        let list = res.data.list || [];
        this.total = res.data.total;
        this.getData(list);
        this.getColumns();
      }
    } catch (err) {
      console.log(err);
    }
  }

  getData(list) {
    list.forEach(e => {
      if (e.contributorList) {
        let len = 0;
        e.contributorList.forEach(_ => {});
        e.contributorList.forEach((item, index) => {
          this.data.push({
            ...e,
            contributeId: e.id,
            id: item.id,
            time: moment(e.joinTime).format('YYYY-MM') || '',
            nickname: item.nickname,
            role: roleMap[item.role],
            records: item.records,
            companyRowSpan: index === 0 ? e.contributorList.length : 0
          });
        });
      } else {
        this.data.push({
          ...e,
          contributeId: e.id,
          time: moment(e.joinTime).format('YYYY-MM') || '',
          companyRowSpan: 1
        });
      }
    });
    console.log(this.data);
  }

  getColumns() {
    this.columns = [
      {
        title: '项目名称',
        dataIndex: 'companyName',
        key: 'companyName',
        width: '15%',
        customRender: (value, row, index) => {
          const obj = {
            children: value,
            attrs: {}
          };
          if (row.companyRowSpan === 0) {
            obj.attrs['rowSpan'] = 0;
          } else {
            obj.attrs['rowSpan'] = row.companyRowSpan;
          }
          return obj;
        }
        // customCell: (value, index) => {
        //   if (value.companyRowSpan === 0) {
        //     return null;
        //   }
        //   const data = {
        //     attrs: {
        //       rowSpan: value.companyRowSpan
        //     }
        //   };
        //   return data;
        // }
      },
      {
        title: '轮次',
        dataIndex: 'roundName',
        key: 'roundName',
        width: '60px',
        customRender: (value, row, index) => {
          const obj = {
            children: value + '轮',
            attrs: {}
          };
          if (row.companyRowSpan === 0) {
            obj.attrs['rowSpan'] = 0;
          } else {
            obj.attrs['rowSpan'] = row.companyRowSpan;
          }
          return obj;
        }
      },
      {
        title: 'DL',
        // dataIndex: 'dlname',
        key: 'dlname',
        // width: '10%',
        width: '80px',
        customRender: (value, row, index) => {
          const obj = {
            children: (
              <a-popover placement="topLeft">
                <template slot="content">
                  <div style="cursor: pointer;" onClick={this.copy.bind(this, 1, row.contributeId)}>
                    https://applink.feishu.cn/client/mini_program/open?appId={this.appId}&path=pages/contribute/index?contributeId={row.contributeId}
                  </div>
                </template>
                {row.dlname}
              </a-popover>
            ),
            attrs: {}
          };
          if (value.companyRowSpan === 0) {
            obj.attrs['rowSpan'] = 0;
          } else {
            obj.attrs['rowSpan'] = value.companyRowSpan;
          }
          return obj;
        }
      },
      {
        title: '交割时间',
        dataIndex: 'time',
        key: 'time',
        width: '100px',
        customRender: (value, row, index) => {
          const obj = {
            children: value,
            attrs: {}
          };
          if (row.companyRowSpan === 0) {
            obj.attrs['rowSpan'] = 0;
          } else {
            obj.attrs['rowSpan'] = row.companyRowSpan;
          }
          return obj;
        }
      },
      {
        title: '贡献者（DL填）',
        // dataIndex: 'nickname',
        key: 'nickname',
        width: '120px',
        scopedSlots: {
          customRender: 'nickname'
        }
      },
      {
        title: '角色',
        dataIndex: 'role',
        key: 'role',
        width: '80px'
      },
      {
        title: 'contribution简述（DL填）',
        dataIndex: 'records',
        key: 'records',
        width: '17%',
        scopedSlots: {
          customRender: 'records'
        },
        customCell: (record, rowIndex) => {
          const obj = {
            attrs: {}
          };
          obj.attrs['colSpan'] = 4;
          return obj;
        }
      },
      {
        title: '评价者自述',
        dataIndex: 'readme',
        width: '10%',
        key: 'readme',
        customRender: (data, row, index) => {
          const obj = {
            attrs: {}
          };
          obj.attrs['colSpan'] = 0;
          return obj;
        }
      },
      {
        title: '约定credit（DL填）',
        width: '10%',
        customRender: (data, row, index) => {
          const obj = {
            attrs: {}
          };
          obj.attrs['colSpan'] = 0;
          return obj;
        }
      },
      {
        title: '对方确认情况（评价者填）',
        width: '12%',
        dataIndex: 'confirm',
        key: 'confirm',
        customRender: (data, row, index) => {
          const obj = {
            attrs: {}
          };
          obj.attrs['colSpan'] = 0;
          return obj;
        }
      }
    ];
  }

  onChange(page, pageSize) {
    this.getList(page);
  }

  async urgeCompany() {
    try {
      this.loading = true;
      let res = await oneClickCollection();
      this.loading = false;
      if (res.code === 200) {
        this.$message.success('催收成功');
      }
    } catch (err) {
      this.loading = false;
      console.log(err);
    }
  }

  filterChange(key) {
    this.filterNow = key;
    this.getList(1);
  }

  handleSearch() {
    this.getList(1);
  }

  copy(type, id) {
    let url;
    if (type === 1) {
      url = `https://applink.feishu.cn/client/mini_program/open?appId=${this.appId}&path=pages/contribute/index?contributeId=${id}`;
    } else if (type === 2) {
      url = `https://applink.feishu.cn/client/mini_program/open?appId=${this.appId}&path=pages/contribute/confirm?contributeId=${id}`;
    }
    let oInput = document.createElement('input');
    oInput.value = url;
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象;
    document.execCommand('Copy');
    this.$message.success('复制成功');
  }
}
export default ProjectContribution;
